import { render, staticRenderFns } from "./no-content.vue?vue&type=template&id=1c439296"
import script from "./no-content.vue?vue&type=script&lang=js"
export * from "./no-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports